import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DiscardByComponentChart from "./DiscardByComponentChart";

// Static data for discard by component
const STATIC_DISCARD_DATA = [
  { component: "PRBC", count: 45 },
  { component: "FFP", count: 28 },
  { component: "Platelets", count: 62 },
  { component: "Cryo", count: 15 },
];

const DiscardByComponentWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Discard by Component")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DiscardByComponentChart data={STATIC_DISCARD_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DiscardByComponentWrapper;
